module.exports = __webpack_public_path__ + "img/Airline.232d40bb.jpg";